import { render } from "./latestblog.vue?vue&type=template&id=3b59da50"
import script from "./latestblog.vue?vue&type=script&lang=js"
export * from "./latestblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__